export default __webpack_public_path__ + "static/uniswap-dbe6034cd96602e3e20a6bb066fddc48.svg";